<template>
  <v-layout v-if="!IsLogin" align-center justify-center fill-height>
    <h1>{{ $t(`nav.disconnect`) }}</h1>
  </v-layout>
  <v-layout v-else>
    <v-layout
      align-center
      justify-center
      v-if="!fnCheckMission(Session, [{ m: DASHBOARD, p: READ }])"
    >
      <v-card flat class="text-center transparent">
        <v-card-title class="font-weight-bold display-1 primary--text">
          Welcome to Lomo
        </v-card-title>
        <v-card-text class="font-weight-bold title">
          Dashboard's coming soon...
        </v-card-text>
      </v-card>
    </v-layout>
    <v-layout v-else>
      <v-col cols :sm="12" class="pa-0">
        <v-card flat tile class="pa-2 text-no-wrap">
          <h2 class="mb-3">
            {{ $t(`table.filter`) }}
          </h2>
          <v-row>
            <v-col cols :sm="3" class="py-3">
              <v-datePickerRange
                v-model="filter.times"
                @change="_fnCallAll()"
              />
            </v-col>
            <v-col cols :sm="3" class="mt-4">
              <v-btnc
                :size="30"
                icon="mdi-download"
                @click="_fnExport()"
                v-if="fnCheckMission(Session, [{ m: DASHBOARD, p: EXPORT }])"
              />
            </v-col>
          </v-row>
          <h2 class="mb-3">
            {{ $t(`table.traffic`) }}
          </h2>
          <v-row class="mb-3">
            <v-col cols :sm="3" class="py-3">
              <v-card color="success" class="pa-4 white--text title">
                <v-layout justify-space-between>
                  <span>User Active:</span>
                  <span>{{ traffic.totalActive || 0 }}</span>
                </v-layout>
              </v-card>
            </v-col>
            <v-col cols :sm="3" class="py-3">
              <v-card color="warning" class="pa-4 white--text title">
                <v-layout justify-space-between>
                  <span>Register Profile:</span>
                  <span>{{ traffic.totalRegisterProfile || 0 }}</span>
                </v-layout>
              </v-card>
            </v-col>
            <v-col cols :sm="3" class="py-3">
              <v-card color="error" class="pa-4 white--text title">
                <v-layout justify-space-between>
                  <span>Post:</span>
                  <span>{{ traffic.totalPost || 0 }}</span>
                </v-layout>
              </v-card>
            </v-col>
            <v-col cols :sm="3" class="py-3">
              <v-card color="info" class="pa-4 white--text title">
                <v-layout justify-space-between>
                  <span>Dating Profile:</span>
                  <span>{{ traffic.totalDatingProfile || 0 }}</span>
                </v-layout>
              </v-card>
            </v-col>
          </v-row>
          <h2 class="mb-3">
            {{ $t(`table.user`) }}
          </h2>
          <v-row class="mb-3">
            <v-col cols :sm="12" class="py-3">
              <v-card class="pa-2 text-no-wrap">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(traffic.list[0]).map((e) => ({
                      text: e,
                      value: e,
                    }))
                  "
                  :items="traffic.list"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Total & Avg</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.posts[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.posts"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Post</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.followers[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.followers"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Follower</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.bearOwners[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.bearOwners"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Bear Owner</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.gifts[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.gifts"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Gift</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.followings[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.followings"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Following</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.bearGives[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.bearGives"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Bear Give</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.heartOwners[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.heartOwners"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Heart Owner</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.commentOwners[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.commentOwners"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Comment Owner</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.candyOwners[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.candyOwners"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Candy Owner</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.heartGives[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.heartGives"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Heart Give</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.commentGives[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.commentGives"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Comment Give</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.candyGives[0])
                      .filter((e) => !['LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="user.candyGives"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Candy Give</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.genders[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="user.genders"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Gender</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.sogiescs[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="user.sogiescs"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Sogiesc</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.ages[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="user.ages"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Age</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.provinces[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="user.provinces"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Province</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(user.relates[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="user.relates"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Relationship</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
          <h2 class="mb-3">
            {{ $t(`table.post`) }}
          </h2>
          <v-row class="mb-3">
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(post.favorites[0])
                      .filter((e) => !['LomoId', 'PostId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="post.favorites"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Favorite</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                    {{ "PostId: " + item.PostId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(post.comments[0])
                      .filter((e) => !['LomoId', 'PostId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                        width: 50,
                      }))
                  "
                  :items="post.comments"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Comment</b>
                  </template>
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                    {{ "PostId: " + item.PostId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
          <h2 class="mb-3">
            {{ $t(`table.dating`) }}
          </h2>
          <v-row class="mb-3">
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(dating.genders[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="dating.genders"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Gender</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(dating.genderSearchs[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="dating.genderSearchs"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Gender Search</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(dating.roles[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="dating.roles"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Role</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(dating.sogiescs[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="dating.sogiescs"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Sogiesc</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(dating.statuss[0]).map((e) => ({
                      text: e,
                      value: e,
                      width: 50,
                    }))
                  "
                  :items="dating.statuss"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Dating Status</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
          <h2 class="mb-3">
            {{ $t(`table.quiz`) }}
          </h2>
          <v-row class="mb-3">
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2 text-no-wrap">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(
                      DQuizRanking.list.length ? DQuizRanking.list[0] : []
                    )
                      .filter((e) => !['id', 'Name', 'CreatedAt'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                      }))
                  "
                  :items="DQuizRanking.list"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>Ranking</b>
                  </template>
                  <template #[`item.LomoId`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                  <template #[`item.CreatedAt`]="{ item }">
                    {{ item.CreatedAt | mDateTime }}
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2 text-no-wrap">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(
                      DQuizByDay.list.length ? DQuizByDay.list[0] : []
                    ).map((e) => ({
                      text: e,
                      value: e,
                    }))
                  "
                  :items="DQuizByDay.list"
                  :items-per-page="3"
                  :footer-props="{ itemsPerPageOptions }"
                >
                  <template v-slot:top class="font-weight-bold">
                    <b>By Day</b>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols :sm="4" class="py-3">
              <v-card class="pa-2 text-no-wrap">
                <v-data-table
                  dense
                  disable-sort
                  :headers="
                    Object.keys(DQuiz.list.length ? DQuiz.list[0] : [])
                      .filter((e) => !['id', 'Name', 'CreatedAt'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                      }))
                  "
                  :items="DQuiz.list"
                  :items-per-page="DQuiz.filter.limit"
                  :footer-props="{ itemsPerPageOptions }"
                  :server-items-length="DQuiz.total"
                  :options.sync="pagingQuiz"
                >
                  <template v-slot:top class="font-weight-bold">
                    <v-layout justify-space-between>
                      <b>Quiz</b>
                      <div :style="{ width: '220px' }">
                        <v-text-field
                          v-model="DQuiz.search"
                          :placeholder="$t(`table.search`) + ' LomoId'"
                          single-line
                          hide-details
                          @keydown.enter="_fnSearchQuiz"
                          dense
                        />
                      </div>
                    </v-layout>
                  </template>
                  <template #[`item.LomoId`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
          <!-- <v-row class="mb-3">
            <v-layout px-3 justify-space-between>
              <h2>
                {{ $t(`table.userDetail`) }}
              </h2>
              <div class="mb-2" :style="{ width: '220px' }">
                <v-text-field
                  v-model="DUsers.search"
                  :placeholder="$t(`table.search`) + ' LomoId'"
                  single-line
                  hide-details
                  @keydown.enter="_fnSearchUsers"
                  dense
                />
              </div>
            </v-layout>
            <v-col cols :sm="12" class="py-3">
              <v-card class="pa-2 text-no-wrap">
                <v-data-table
                  :items="DUsers.list"
                  :headers="
                    Object.keys(DUsers.list.length ? DUsers.list[0] : [])
                      .filter((e) => !['id', 'LomoId'].includes(e))
                      .map((e) => ({
                        text: e,
                        value: e,
                      }))
                  "
                  item-key="id"
                  :items-per-page="DUsers.filter.limit"
                  :footer-props="{ itemsPerPageOptions: DUsers.itemPages }"
                  :server-items-length="DUsers.total"
                  :options.sync="pagingUsers"
                  dense
                  disable-sort
                >
                  <template #[`item.Name`]="{ item }">
                    {{ "Name: " + item.Name }}<br />
                    {{ "LomoId: " + item.LomoId }}<br />
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row> -->
        </v-card>
      </v-col>
    </v-layout>
  </v-layout>
</template>

<script>
import XLSX from "xlsx";

export default {
  data() {
    return {
      filter: {
        times: null,
      },
      itemsPerPageOptions: [3, 10, 20, 50, 100],
      traffic: { list: [{}] },
      user: {
        posts: [{}],
        gifts: [{}],
        bearOwners: [{}],
        bearGives: [{}],
        followers: [{}],
        followings: [{}],
        heartOwners: [{}],
        heartGives: [{}],
        commentOwners: [{}],
        commentGives: [{}],
        candyOwners: [{}],
        candyGives: [{}],
        genders: [{}],
        provinces: [{}],
        relates: [{}],
        sogiescs: [{}],
        ages: [{}],
      },
      post: {
        topics: [{}],
        sogiescs: [{}],
        favorites: [{}],
        comments: [{}],
      },
      dating: {
        genders: [{}],
        genderSearchs: [{}],
        roles: [{}],
        sogiescs: [{}],
        statuss: [{}],
      },
      pagingQuiz: {},
      pagingUsers: {},
    };
  },
  created() {
    if (this.IsLogin) {
      this.filter.times = [
        this.$moment().startOf("day").unix(),
        this.$moment().endOf("day").unix(),
      ];
      this.DQuiz.filter.limit = 3;
    }
  },
  watch: {
    pagingQuiz: function (val) {
      const { itemsPerPage, page } = val;
      this.DQuiz.filter.limit = itemsPerPage;
      this.DQuiz.filter.page = page;
      this._fnCallListQuiz();
    },
    // pagingUsers: function (val) {
    //   const { itemsPerPage, page } = val;
    //   this.DUsers.filter.limit = itemsPerPage;
    //   this.DUsers.filter.page = page;
    //   this._fnCallListUsers();
    // },
  },
  methods: {
    _fnCallAll() {
      this._fnDashboard();
      this._fnCallListQuiz();
      // this._fnCallListUsers();
    },
    _fnCallListQuiz() {
      this.DQuiz.filter.times = this.filter.times.map(
        (e) => this.$moment.unix(e).utc(true).unix() * 1000
      );
      this.fnGets({
        url: `/v1/admin/dashboard/quiz`,
        model: "DQuiz",
      });
    },
    _fnSearchQuiz({ target: { value } }) {
      if (!value) delete this.DQuiz.filter.$text;
      else this.DQuiz.filter.$text = value;
      this._fnCallListQuiz();
    },
    // _fnCallListUsers() {
    //   this.DUsers.filter.times = this.filter.times.map(
    //     (e) => this.$moment.unix(e).utc(true).unix() * 1000
    //   );
    //   this.fnGets({
    //     url: `/v1/admin/dashboard/users`,
    //     model: "DUsers",
    //   });
    // },
    // _fnSearchUsers({ target: { value } }) {
    //   if (!value) delete this.DUsers.filter.lomoId;
    //   else this.DUsers.filter.lomoId = value;
    //   this._fnCallListUsers();
    // },
    _fnDashboard() {
      const times = this.filter.times.map(
        (e) => this.$moment.unix(e).utc(true).unix() * 1000
      );
      this.fnGet({
        url: `/v1/admin/dashboard/traffic?times=${times}`,
        model: "DTraffic",
      }).then(({ code, data }) => {
        if (code == 200) this.traffic = data;
      });
      this.fnGet({
        url: `/v1/admin/dashboard/user?times=${times}`,
        model: "DUser",
      }).then(({ code, data }) => {
        if (code == 200) {
          if (data.posts.length) this.user.posts = data.posts;
          if (data.gifts.length) this.user.gifts = data.gifts;
          if (data.bearOwners.length) this.user.bearOwners = data.bearOwners;
          if (data.bearGives.length) this.user.bearGives = data.bearGives;
          if (data.followers.length) this.user.followers = data.followers;
          if (data.followings.length) this.user.followings = data.followings;
          if (data.heartOwners.length) this.user.heartOwners = data.heartOwners;
          if (data.heartGives.length) this.user.heartGives = data.heartGives;
          if (data.commentOwners.length)
            this.user.commentOwners = data.commentOwners;
          if (data.commentGives.length)
            this.user.commentGives = data.commentGives;
          if (data.candyOwners.length) this.user.candyOwners = data.candyOwners;
          if (data.candyGives.length) this.user.candyGives = data.candyGives;
          if (data.genders.length) this.user.genders = data.genders;
          if (data.provinces.length) this.user.provinces = data.provinces;
          if (data.relates.length) this.user.relates = data.relates;
          if (data.sogiescs.length) this.user.sogiescs = data.sogiescs;
          if (data.ages.length) this.user.ages = data.ages;
        }
      });
      this.fnGet({
        url: `/v1/admin/dashboard/post?times=${times}`,
        model: "DPost",
      }).then(({ code, data }) => {
        if (code == 200) {
          if (data.favorites.length) this.post.favorites = data.favorites;
          if (data.comments.length) this.post.comments = data.comments;
        }
      });
      this.fnGet({
        url: `/v1/admin/dashboard/dating?times=${times}`,
        model: "DDating",
      }).then(({ code, data }) => {
        if (code == 200) {
          if (data.genders.length) this.dating.genders = data.genders;
          if (data.genderSearchs.length)
            this.dating.genderSearchs = data.genderSearchs;
          if (data.roles.length) this.dating.roles = data.roles;
          if (data.sogiescs.length) this.dating.sogiescs = data.sogiescs;
          if (data.statuss.length) this.dating.statuss = data.statuss;
        }
      });
      this.DQuizRanking.filter.times = times;
      this.fnGets({
        url: `/v1/admin/dashboard/quiz/ranking`,
        model: "DQuizRanking",
      });
      this.DQuizByDay.filter.times = times;
      this.fnGets({
        url: `/v1/admin/dashboard/quiz/by-day`,
        model: "DQuizByDay",
      });
    },
    _fnExport() {
      const wb = XLSX.utils.book_new();

      const traffic = [
        { name: "User Active", total: this.DTraffic.obj.totalActive },
        {
          name: "Register Profile",
          total: this.DTraffic.obj.totalRegisterProfile,
        },
        { name: "News Feed", total: this.DTraffic.obj.totalPost },
        { name: "Dating Profile", total: this.DTraffic.obj.totalDatingProfile },
      ];
      const xlsxDataTraffic = XLSX.utils.json_to_sheet(traffic);
      XLSX.utils.book_append_sheet(wb, xlsxDataTraffic, "traffic");
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DTraffic.obj.list),
        "Total & Avg"
      );

      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.posts),
        "Top Post"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.gifts),
        "Top Gift"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.bearOwners),
        "Top Bear Owner"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.bearGives),
        "Top Bear Give"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.followers),
        "Top Follower"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.followings),
        "Top Following"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.heartOwners),
        "Top Heart Owner"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.heartGives),
        "Top Heart Give"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.commentOwners),
        "Top Comment Owner"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.commentGives),
        "Top Comment Give"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.candyOwners),
        "Top Candy Owner"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.candyGives),
        "Top Candy Give"
      );

      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.genders),
        "User Gender"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.sogiescs),
        "User Sogiesc"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.ages),
        "User Age"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.relates),
        "User Relationship"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DUser.obj.provinces),
        "User Province"
      );

      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DPost.obj.favorites),
        "Post Favorite"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DPost.obj.comments),
        "Post Comment"
      );

      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DDating.obj.genders),
        "Dating Gender"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DDating.obj.genderSearchs),
        "Dating Gender Search"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DDating.obj.sogiescs),
        "Dating Sogiesc"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DDating.obj.roles),
        "Dating Role"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DDating.obj.statuss),
        "Dating Status"
      );

      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(
          this.DQuiz.list.map((e) => ({
            ...e,
            CreatedAt: this.$moment
              .unix(e.CreatedAt)
              .format("HH:mm DD/MM/YYYY"),
          }))
        ),
        "Quiz"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(
          this.DQuizRanking.list.map((e) => ({
            ...e,
            CreatedAt: this.$moment
              .unix(e.CreatedAt)
              .format("HH:mm DD/MM/YYYY"),
          }))
        ),
        "Quiz Ranking"
      );
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(this.DQuizByDay.list),
        "Quiz By Day"
      );

      // XLSX.utils.book_append_sheet(
      //   wb,
      //   XLSX.utils.json_to_sheet(this.DUsers.list),
      //   "User Detail"
      // );

      XLSX.writeFile(
        wb,
        `Dashboard-${this.$moment().format("YYYYMMDDHHmmss")}.xlsx`
      );
    },
  },
};
</script>